import { useEffect } from "react";

import { useOpenModalCount } from "@/lib/zustand/useOpenModalCount";

// The one way an overlay tells the document-level keyboard shortcuts to stand down while it is up: pass the overlay's own open flag and it is counted for exactly as long as it is shown. Every surface that TAKES THE KEYBOARD registers — the shared Modal and each click-owned rack card/popover — because the shortcuts bind on `document` and the cards dismiss on `window`, so a real keypress reaches the shortcut first: without the registration Delete reaches the score behind an open card, and the Escape that dismisses the card is spent clearing the selection under it in the same press. A card that deliberately leaves the roll live (the pitch card, whose knobs act on the selection you keep making while it is open) does not register — it owns its own Escape instead.
export const useRegisterOpenOverlay = (isOpen: boolean) => {
  const registerOpenModal = useOpenModalCount(
    (state) => state.registerOpenModal
  );
  const unregisterOpenModal = useOpenModalCount(
    (state) => state.unregisterOpenModal
  );

  // Keyed on the open flag (not a leave animation) so the shortcuts come back the moment the overlay is logically closed.
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    registerOpenModal();
    return () => unregisterOpenModal();
  }, [isOpen, registerOpenModal, unregisterOpenModal]);
};
